// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"621":"e191f742","809":"7342ec46","878":"c7390d7d"}[chunkId] + ".css";
};